import React from 'react';
import { generatePath, NavLink, useLocation } from 'react-router-dom';
import CallRecordTypeIcon from 'flow/components/custom-components/CallRecordTypeIcon';
import useAppContext from 'flow/hooks/useAppContext';
import { CallRecord } from 'flow/types/CallRecord';
import { routes } from 'flow/types/routes';
import { TypedMap } from 'flow/types/TypedMap';
import { getFormattedDateAndTime } from 'flow/utils';
import {
    callRecordIsMissed,
    getCallTypeTextUserFriendly,
    getDateOfPersonalCallRecord,
} from 'flow/utils/call-records-utils';
import { twMerge } from 'tailwind-merge';

interface Props {
    callRecords: TypedMap<CallRecord>[];
}

const ContactCallRecordItems = ({ callRecords }: Props) => {
    const { i18next } = useAppContext();
    const { pathname } = useLocation();

    const getCallRecordColorClass = (callRecord: TypedMap<CallRecord>) => {
        if (callRecord.get('voiceMessage')) {
            return 'text-gray-800';
        }

        const callIsMissed = callRecordIsMissed(callRecord);

        if (callIsMissed) {
            return 'text-red';
        }

        return 'text-gray-800';
    };

    return (
        <main className="flex grow flex-col pb-6">
            {callRecords
                .slice(0, 8)
                .map((callRecord) => (
                    <NavLink
                        key={callRecord.get('key')}
                        className="mx-4 flex items-center justify-between gap-1 p-2 whitespace-nowrap hover:bg-gray-200"
                        to={{
                            pathname: generatePath(
                                routes['calls.callRecordKey'],
                                {
                                    callRecordKey: callRecord.get('key'),
                                },
                            ),
                            state: { from: pathname },
                        }}
                    >
                        <CallRecordTypeIcon
                            callRecordKey={callRecord.get('key')}
                        />
                        <div
                            className={twMerge(
                                'flex w-full items-center justify-between overflow-hidden whitespace-nowrap',
                                getCallRecordColorClass(callRecord),
                            )}
                        >
                            <div className="flex items-end leading-5">
                                {getCallTypeTextUserFriendly(
                                    callRecord,
                                    i18next,
                                )}
                            </div>
                            <div className="text-xs text-gray-500">
                                {getFormattedDateAndTime(
                                    getDateOfPersonalCallRecord(callRecord),
                                    i18next,
                                )}
                            </div>
                        </div>
                    </NavLink>
                ))
                .valueSeq()}
        </main>
    );
};

export default ContactCallRecordItems;
